




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { CustomCols } from './MultipleImages.vue';

interface Image {
    url: string;
    title: string;
}

@Component
export default class ImageMasonry extends Vue {
    @Prop({ default: () => [] }) private images!: Image[];
    @Prop({ default: true }) private showDescription!: boolean;
    @Prop({ default: () => ({ default: 5, 900: 1 }) }) private cols!: CustomCols;

    constructor() {
        super();
    }
}
